export function preProcessToInt(value: unknown) {
    if (typeof value === "string") {
        return parseInt(value, 10);
    }
    return value;
}
